import {
  SimpleTreeView as MuiSimpleTreeView,
  SimpleTreeViewProps as MuiSimpleTreeViewProps,
} from '@mui/x-tree-view';

function SimpleTreeView<T extends boolean | undefined>(
  props: MuiSimpleTreeViewProps<T>
) {
  return <MuiSimpleTreeView {...props} />;
}

export default SimpleTreeView;
